import axios from "axios";

const GetAPI = async (getapi, queryParams = {}, customHeader) => {
  const headersValue = {
    "Content-type": "application/json; charset=UTF-8",
    Authorization: "website"
  };

  const headers = customHeader !== undefined ? customHeader : headersValue;

  return axios
    .get(getapi, {
      headers,
      params: queryParams,
    })
    .then((res) => {
        return res;
    })
    .catch((err) => {
      return err;
    });
};

export default GetAPI;
